import checkoutReducer from "@/store/features/checkout";
import enrolReducer from "@/store/features/enrolment";
import persistedRegistrationReducer from "@/store/features/registration";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
    FLUSH,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
    REHYDRATE
} from "redux-persist";

import electivesReducer from "./features/electives";
import parentReducer from "./features/parent";
import reportingReducer from "./features/reporting";

const isInDevEnv = () =>
    /\b(dev|dev[123]|rc)\b/.test(process.env.APP_URL ?? "") ||
    process.env.NODE_ENV === "development";

export const rootReducer = combineReducers({
    checkout: checkoutReducer,
    enrol: enrolReducer,
    registration: persistedRegistrationReducer,
    electives: electivesReducer,
    parent: parentReducer,
    reporting: reportingReducer
});

export const store = configureStore({
    reducer: rootReducer,
    devTools: isInDevEnv(),
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER
                ]
            }
        })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
